/* eslint-disable no-console */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import ContentLoader from 'react-content-loader';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// global variables
import { flashMessages } from 'config';
// our components
import FlashState from 'helpers/flashState';
import AuthContext from 'helpers/authContext';
import { bulkUpdate } from 'helpers/updateMutationsHelper';
import { Query, Mutation } from 'components/common/Query';
import { REVIEW_ADS_MUTATION, PUBLISH_ADS_MUTATION } from 'components/Ad/List';
import {
  PAUSE_PAIDAD_MUTATION,
  EXTEND_PAIDAD_MUTATION,
  CANCEL_PAIDAD_MUTATION,
  RESUME_PAIDAD_MUTATION,
} from 'components/PaidAd/List';
import { PAID_AD } from 'routes/paths';
import qs from 'helpers/queryStrings';
import RouterContext from 'helpers/routerContext';
import PaidAdDetails from './Details';

/**
 * Mocked logs data
 */
const mockData = {
  logs: [
    {
      // First story
      badgeColor: 'danger',
      title: 'Some Title',
      titleColor: 'danger',
      body: (
        <p>
          Wifey made the best Fathers Day meal ever. So thankful so happy so
          blessed. Thank you for making my family We just had fun with the
          “future” theme !!! It was a fun night all together ... The always rude
          Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in
          downtown.
        </p>
      ),
      footerTitle: '11 hours ago via Twitter',
    },
    {
      // Second story
      badgeColor: 'success',
      title: 'Another One',
      titleColor: 'success',
      body: (
        <p>
          Thank God for the support of my wife and real friends. I also wanted
          to point out that it’s the first album to go number 1 off of
          streaming!!! I love you Ellen and also my number one design rule of
          anything I do from shoes to music to homes is that Kim has to like
          it....
        </p>
      ),
    },
    {
      // Fourth story
      badgeColor: 'warning',
      title: 'Another One',
      titleColor: 'warning',
      body: (
        <p>
          Tune into Big Boys 92.3 Im about to play the first single from Cruel
          Winter also to Kim’s hair and makeup Lorraine jewelry and the whole
          style squad at Balmain and the Yeezy team. Thank you Anna for the
          invite thank you to the whole Vogue team
        </p>
      ),
    },
  ],
};

/**
 * Query to fetch an Ad from api
 */
export const PAIDAD_QUERY = gql`
  query PaidAd($id: ID!) {
    paidAd(id: $id) {
      id
      createdOn
      startDate
      endDate
      owner {
        id
        fullname
        email
        phone
      }
      manager {
        id
        fullname
        email
      }
      duration {
        years
        months
        days
        hours
        minutes
        seconds
      }
      adsRelatedToPromotion
      ... on AdminAutoPaidAdType {
        frequency {
          years
          months
          days
          hours
          minutes
          seconds
        }
        schedule
        status
        currency
        userPrice
        netSale
        secondaryCurrency
        secondaryUserPrice
        secondaryNetSale
        consumedCredit
        consumedTime
        refundedAmount
        lastTask {
          name
          scheduleTime
          createTime
          dispatchCount
          responseCount
        }
        lead
        hasPromotion
        online
        refundStatus
      }
      ad {
        id
        title
        price
        currency
        description
        user {
          id
          email
          fullname
        }
        subcategory {
          id
          title
          parentCategory {
            id
            title
          }
        }
        province {
          name
        }
        municipality {
          name
        }
        permalink
        name
        email
        firstPhone
        firstPhonePrefix
        firstPhoneType
        secondPhone
        secondPhonePrefix
        secondPhoneType
        whatsapp
        contactInfo
        images {
          id
          lastStatus
          status
          urls {
            thumb
            high
          }
        }
        isAuto
        updatedOn
        updatedOnByUser
        updatedOnToOrder
        matchedRules
        status
        isPublished
        reviewed
        reviewedBy {
          id
          fullname
        }
        reviewedOn
        updateCount
        ipInsert
        ipUpdate
        countryInsert
        countryUpdate
        botScoreInsert
        botScoreUpdate
        botScoreInsertErrors
        botScoreUpdateErrors
        viewCount
        offensive: flag(flagType: PROHIBIDO_OFENSIVO) {
          lastFlaggedOn
          total
        }
        spam: flag(flagType: REPETIDO_SPAM) {
          lastFlaggedOn
          total
        }
        classified: flag(flagType: MAL_CATEGORIZADO) {
          lastFlaggedOn
          total
        }
        scam: flag(flagType: ESTAFA) {
          lastFlaggedOn
          total
        }
        joke: flag(flagType: FALSO_BROMA) {
          lastFlaggedOn
          total
        }
      }
    }
  }
`;

/**
 * Mutation to extend paidad with promotion
 */
export const EXTEND_PAIDAD_WITH_PROMOTION_MUTATION = gql`
  mutation($id: ID) {
    extendPromotionAutoPaidAds(input: { id: $id }) {
      autoPaidAd {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to rerun paidad task
 */
export const RUN_AUTOPAIDAD_TASK_MUTATION = gql`
  mutation($ids: [ID]!) {
    runAutoPaidAdTask(input: { ids: $ids }) {
      successIds
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * Mutation to refund payment
 */
export const PAYMENT_REFUND_MUTATION = gql`
  mutation($autoPaidAd: ID!, $total: Boolean!) {
    paymentRefund(input: { autoPaidAd: $autoPaidAd, total: $total }) {
      errors {
        field
        messages
      }
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class PaidAdDetailsContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.Compose = adopt({
      mutateAdPublish: this.adPublish,
      mutateAdReview: this.adReview,
      mutatePaidAdExtend: this.paidAdExtend,
      mutatePaidAdExtendWithPromotion: this.paidAdExtendWithPromotion,
      mutatePaidAdPause: this.paidAdPause,
      mutatePaidAdResume: this.paidAdResume,
      mutatePaidAdCancel: this.paidAdCancel,
      mutatePaidAdRunTask: this.paidAdRunTask,
      mutatePaymentRefund: this.paymentRefund,
      query: this.paidAd,
    });
    this.fetchMore = () => {};
  }

  /**
   * @description
   * Paidad's query callback to compose with mutations.
   *
   * @param {*} render - Query's render props.
   * @returns {*} Query component.
   */
  paidAd = ({ render }) => {
    const { id } = this.props;
    return (
      <Query
        query={PAIDAD_QUERY}
        variables={{ id }}
        notifyOnNetworkStatusChange
        fetchPolicy="cache-and-network"
      >
        {({ data, loading, fetchMore }) => {
          this.fetchMore = fetchMore;
          return render({ data, loading, fetchMore });
        }}
      </Query>
    );
  };

  /**
   * @description
   * Mutation review callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adReview = ({ render }) => (
    <AuthContext.Consumer>
      {({ id, fullname }) => (
        <Mutation
          mutation={REVIEW_ADS_MUTATION}
          update={(cache, { data: { reviewAd } }) => {
            const data = {
              reviewed: true,
              reviewedBy: { id, fullname, __typename: 'UserType' },
              reviewedOn: Date.now(),
              __typename: 'AdminAdType',
            };

            const field = `${'reviewed ' +
              'reviewedBy {id fullname} ' +
              'reviewedOn '}`;

            bulkUpdate(
              cache,
              'AdminAdType',
              'Review',
              field,
              data,
              reviewAd.successIds,
            );
          }}
        >
          {handleAdReview => render({ handleAdReview })}
        </Mutation>
      )}
    </AuthContext.Consumer>
  );

  /**
   * @description
   * Mutation publish callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  adPublish = ({ render }) => (
    <Mutation
      mutation={PUBLISH_ADS_MUTATION}
      update={(cache, { data: { publishAd } }) => {
        const data = {
          status: 'PUBLISHED_BY_MODERATOR',
          __typename: 'AdminAdType',
        };

        bulkUpdate(
          cache,
          'AdminAdType',
          'Publish',
          'status',
          data,
          publishAd.successIds,
        );
      }}
    >
      {(handleAdPublish, { loading }) =>
        render({ handleAdPublish, loadingAdPublish: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation pause callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  paidAdPause = ({ render }) => (
    <Mutation
      mutation={PAUSE_PAIDAD_MUTATION}
      update={(cache, { data: { pauseAutoPaidAd } }) => {
        const data = { status: 'PAUSED', __typename: 'AdminAutoPaidAdType' };

        bulkUpdate(
          cache,
          'AdminAutoPaidAdType',
          'pause',
          'status',
          data,
          pauseAutoPaidAd.successIds,
        );
      }}
    >
      {(handlePaidAdPause, { loading }) =>
        render({ handlePaidAdPause, loadingPaidAdPause: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation cancel callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  paidAdCancel = ({ render }) => (
    <Mutation
      mutation={CANCEL_PAIDAD_MUTATION}
      update={(cache, { data: { cancelAutoPaidAd } }) => {
        const data = { status: 'CANCELLED', __typename: 'AdminAutoPaidAdType' };

        bulkUpdate(
          cache,
          'AdminAutoPaidAdType',
          'cancel',
          'status',
          data,
          cancelAutoPaidAd.successIds,
        );
      }}
    >
      {(handlePaidAdCancel, { loading }) =>
        render({ handlePaidAdCancel, loadingPaidAdCancel: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation resume callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  paidAdResume = ({ render }) => (
    <Mutation
      mutation={RESUME_PAIDAD_MUTATION}
      update={() => {
        this.fetchMore({
          updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
        });
      }}
    >
      {(handlePaidAdResume, { loading }) =>
        render({ handlePaidAdResume, loadingPaidAdResume: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation extend callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  paidAdExtend = ({ render }) => (
    <Mutation
      mutation={EXTEND_PAIDAD_MUTATION}
      update={() => {
        this.fetchMore({
          updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
        });
      }}
    >
      {(handlePaidAdExtend, { loading }) =>
        render({ handlePaidAdExtend, loadingPaidAdExtend: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation extend with promotion callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  paidAdExtendWithPromotion = ({ render }) => (
    <Mutation
      mutation={EXTEND_PAIDAD_WITH_PROMOTION_MUTATION}
      onCompleted={this.mutationExtendWithPromotionCompleted}
      update={() => {
        this.fetchMore({
          updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
        });
      }}
    >
      {(handlePaidAdExtendWithPromotion, { loading }) =>
        render({
          handlePaidAdExtendWithPromotion,
          loadingPaidAdExtendWithPromotion: loading,
        })
      }
    </Mutation>
  );

  /**
   * @description
   * Mutation extend callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  paidAdRunTask = ({ render }) => (
    <Mutation
      mutation={RUN_AUTOPAIDAD_TASK_MUTATION}
      update={() => {
        this.fetchMore({
          updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
        });
      }}
    >
      {handlePaidAdRunTask => render({ handlePaidAdRunTask })}
    </Mutation>
  );

  /**
   * @description
   * Mutation extend callback.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  paymentRefund = ({ render }) => (
    <Mutation
      mutation={PAYMENT_REFUND_MUTATION}
      update={() => {
        this.fetchMore({
          updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
        });
      }}
    >
      {(handlePaymentRefund, { loading }) =>
        render({ handlePaymentRefund, loadingPaidAdExtend: loading })
      }
    </Mutation>
  );

  /**
   * @description
   * OnComplete extend with promotion mutation.
   *
   * @param {Object} data - Mutation result.
   * @returns {undefined} - No returns value.
   */
  mutationExtendWithPromotionCompleted = async data => {
    const history = this.context;
    const { t } = this.props;
    const { errors, autoPaidAd } = data.extendPromotionAutoPaidAds;
    if (errors) {
      this.setState({ errors });
    } else {
      FlashState.set(
        'message',
        t(`flash_messages.${flashMessages.EXTENDED_WITH_PROMO}`),
      );
      history.push({
        pathname: PAID_AD.LIST,
        search: qs.stringify({
          fromSamePromotion: autoPaidAd.id,
        }),
      });
    }
  };

  /**
   * @description
   * Refresh the list.
   * @returns {Function} - Fetch More function.
   */
  handleRefresh = () => {
    this.fetchMore({
      updateQuery: (_, { fetchMoreResult }) => fetchMoreResult,
    });
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ errors: [] });
  };

  /**
   * @description
   * Render PaidAdDetails component.
   * @returns {*} AdsRead component.
   */
  render() {
    const { errors } = this.state;
    return (
      <this.Compose>
        {({
          mutateAdReview: { handleAdReview, loadingAdReview },
          mutateAdPublish: { handleAdPublish, loadingAdPublish },
          mutatePaidAdExtend: { handlePaidAdExtend, loadingPaidAdExtend },
          mutatePaidAdExtendWithPromotion: {
            handlePaidAdExtendWithPromotion,
            loadingPaidAdExtendWithPromotion,
          },
          mutatePaidAdPause: { handlePaidAdPause, loadingPaidAdPause },
          mutatePaidAdResume: { handlePaidAdResume, loadingPaidAdResume },
          mutatePaidAdCancel: { handlePaidAdCancel, loadingPaidAdCancel },
          mutatePaidAdRunTask: { handlePaidAdRunTask },
          mutatePaymentRefund: { handlePaymentRefund, loadingPaymentRefund },
          query: { data },
        }) => {
          if (Object.keys(data).length !== 0) {
            return (
              <PaidAdDetails
                data={{ ...data, ...mockData }}
                adReview={items =>
                  handleAdReview({ variables: { ids: items } })
                }
                adPublish={items =>
                  handleAdPublish({ variables: { ids: items } })
                }
                adActionLoading={loadingAdReview || loadingAdPublish}
                paidAdCancel={items =>
                  handlePaidAdCancel({ variables: { ids: items } })
                }
                paidAdExtend={items =>
                  handlePaidAdExtend({ variables: { ids: items } })
                }
                paidAdExtendWithPromotion={id => {
                  handlePaidAdExtendWithPromotion({ variables: { id } });
                }}
                paidAdPause={items =>
                  handlePaidAdPause({ variables: { ids: items } })
                }
                paidAdResume={items =>
                  handlePaidAdResume({ variables: { ids: items } })
                }
                paidAdRunTask={items =>
                  handlePaidAdRunTask({ variables: { ids: items } })
                }
                paymentRefund={variables => handlePaymentRefund({ variables })}
                paidAdActionLoading={
                  loadingPaidAdCancel ||
                  loadingPaidAdExtend ||
                  loadingPaidAdResume ||
                  loadingPaidAdPause ||
                  loadingPaymentRefund ||
                  loadingPaidAdExtendWithPromotion
                }
                refresh={this.handleRefresh}
                errors={errors}
                closeNotification={this.handleCloseNotification}
              />
            );
          }
          return (
            <ContentLoader
              height={871}
              width={1073}
              speed={2}
              primaryColor="#d9d9d9"
              secondaryColor="#ecebeb"
            >
              <path
                // eslint-disable-next-line max-len
                d="M8,61 L292,61 C296.418278,61 300,64.581722 300,69 L300,71 C300,75.418278 296.418278,79 292,79 L8,79 C3.581722,79 5.41083001e-16,75.418278 0,71 L0,69 C-5.41083001e-16,64.581722 3.581722,61 8,61 Z M486,61 L554,61 C558.418278,61 562,64.581722 562,69 L562,71 C562,75.418278 558.418278,79 554,79 L486,79 C481.581722,79 478,75.418278 478,71 L478,69 C478,64.581722 481.581722,61 486,61 Z M590,61 L700,61 C704.418278,61 708,64.581722 708,69 L708,71 C708,75.418278 704.418278,79 700,79 L590,79 C585.581722,79 582,75.418278 582,71 L582,69 C582,64.581722 585.581722,61 590,61 Z M764,61 L1065,61 C1069.41828,61 1073,64.581722 1073,69 L1073,121 C1073,125.418278 1069.41828,129 1065,129 L764,129 C759.581722,129 756,125.418278 756,121 L756,69 C756,64.581722 759.581722,61 764,61 Z M764,153 L1065,153 C1069.41828,153 1073,156.581722 1073,161 L1073,661 C1073,665.418278 1069.41828,669 1065,669 L764,669 C759.581722,669 756,665.418278 756,661 L756,161 C756,156.581722 759.581722,153 764,153 Z M764,685 L1065,685 C1069.41828,685 1073,688.581722 1073,693 L1073,863 C1073,867.418278 1069.41828,871 1065,871 L764,871 C759.581722,871 756,867.418278 756,863 L756,693 C756,688.581722 759.581722,685 764,685 Z M8,111 L700,111 C704.418278,111 708,114.581722 708,119 L708,121 C708,125.418278 704.418278,129 700,129 L8,129 C3.581722,129 5.41083001e-16,125.418278 0,121 L0,119 C-5.41083001e-16,114.581722 3.581722,111 8,111 Z M8,137 L397,137 C401.418278,137 405,140.581722 405,145 L405,147 C405,151.418278 401.418278,155 397,155 L8,155 C3.581722,155 5.41083001e-16,151.418278 0,147 L0,145 C-5.41083001e-16,140.581722 3.581722,137 8,137 Z M8,226 L700,226 C704.418278,226 708,229.581722 708,234 L708,598 C708,602.418278 704.418278,606 700,606 L8,606 C3.581722,606 5.41083001e-16,602.418278 0,598 L0,234 C-5.41083001e-16,229.581722 3.581722,226 8,226 Z M8,187 L129,187 C133.418278,187 137,190.581722 137,195 L137,197 C137,201.418278 133.418278,205 129,205 L8,205 C3.581722,205 5.41083001e-16,201.418278 0,197 L0,195 C-5.41083001e-16,190.581722 3.581722,187 8,187 Z M439,187 L700,187 C704.418278,187 708,190.581722 708,195 L708,197 C708,201.418278 704.418278,205 700,205 L439,205 C434.581722,205 431,201.418278 431,197 L431,195 C431,190.581722 434.581722,187 439,187 Z M19.5,0 L163.5,0 C174.269553,-1.97833472e-15 183,8.73044738 183,19.5 C183,30.2695526 174.269553,39 163.5,39 L19.5,39 C8.73044738,39 1.31888981e-15,30.2695526 0,19.5 C-1.31888981e-15,8.73044738 8.73044738,1.97833472e-15 19.5,0 Z M225.5,0 L345.5,0 C356.269553,-1.97833472e-15 365,8.73044738 365,19.5 C365,30.2695526 356.269553,39 345.5,39 L225.5,39 C214.730447,39 206,30.2695526 206,19.5 C206,8.73044738 214.730447,1.97833472e-15 225.5,0 Z"
                fill="#E5EAEC"
              />
            </ContentLoader>
          );
        }}
      </this.Compose>
    );
  }
}

/**
 * PaidAdDetailsContainer PropTypes
 * @param id - prop to know id of the Paidad
 */
PaidAdDetailsContainer.propTypes = {
  id: PropTypes.string.isRequired,
};

export default withTranslation()(PaidAdDetailsContainer);
